import React from 'react';
import { Line } from 'react-konva';
import { PATH_COLOR, PATH_WIDTH } from '../../track/ground/constants';
import { canonicalToCanvas, ProcessedPlayer, Viewport } from '../lib';

export type pathType = {
  timestamp: number;
  x: number;
  _x: number;
  y: number;
  _y: number;
}[];

export type PropsPath = { pathData?: ProcessedPlayer; vp: Viewport; };

const Path = React.memo(( props: PropsPath ) => {
  const {pathData, vp} = props;

  if (!pathData) return null;

  const paths: number[][] = [[]];
  let lineNumber = 0;

  pathData.samples.forEach(( p ) => {
    if (p.x === null || p.y === null) {
      lineNumber += 1;
      paths[lineNumber] = [];
    } else {
      const canvasPoint = canonicalToCanvas(p, vp);

      paths[lineNumber].push(canvasPoint.cx);
      paths[lineNumber].push(canvasPoint.cy);
    }
  });

  return (
    <>
      {
        paths.map(( path, idx ) => (
          <Line
            /* eslint-disable-next-line react/no-array-index-key */
            key={idx}
            points={path}
            stroke={PATH_COLOR}
            strokeWidth={PATH_WIDTH}
          />
        ))
      }
    </>
  );
});

export default Path;
